var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content-hero-banner",style:({backgroundImage: `url(${_vm.backgroundImage}`})},[_c('div',{staticClass:"content-hero-banner__content"},[_c('BannerTitle',{attrs:{"title":_vm.data.title}}),_c('BannerDescription',{attrs:{"wide":"","description":_vm.data.description}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }